import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";
import { Award, Lock } from "lucide-react";

export default function AdminLogin() {
  const { login, user } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  React.useEffect(() => { if (user && user.role === "admin") nav("/admin"); }, [user, nav]);
  const submit = async (e) => {
    e.preventDefault(); setLoading(true);
    try { const u = await login(email, password); if (u.role !== "admin") { toast.error("Akun bukan admin"); } else { nav("/admin"); } }
    catch (err) { toast.error(err.response?.data?.detail || "Login gagal"); }
    setLoading(false);
  };
  return (
    <div className="min-h-screen bg-emerald-950 flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        <div className="text-center mb-8">
          <div className="mx-auto w-14 h-14 rounded-2xl gold-gradient flex items-center justify-center mb-4"><Award className="w-7 h-7 text-emerald-950" strokeWidth={2.5} /></div>
          <h1 className="font-display text-2xl font-extrabold text-white">Admin LSP Realestat</h1>
          <p className="text-white/60 text-sm mt-2">Masuk untuk mengelola website</p>
        </div>
        <form onSubmit={submit} className="bg-white rounded-2xl p-8 space-y-5">
          <div>
            <label className="text-xs font-bold uppercase tracking-widest text-slate-600">Email</label>
            <input type="email" required value={email} onChange={e => setEmail(e.target.value)} data-testid="admin-email" className="mt-1.5 w-full px-4 py-3 rounded-lg border-2 border-slate-200 focus:border-emerald-700 outline-none text-sm" />
          </div>
          <div>
            <label className="text-xs font-bold uppercase tracking-widest text-slate-600">Password</label>
            <input type="password" required value={password} onChange={e => setPassword(e.target.value)} data-testid="admin-password" className="mt-1.5 w-full px-4 py-3 rounded-lg border-2 border-slate-200 focus:border-emerald-700 outline-none text-sm" />
          </div>
          <button disabled={loading} data-testid="admin-login-btn" className="w-full inline-flex items-center justify-center gap-2 py-3 rounded-lg bg-emerald-950 text-white font-bold text-sm hover:bg-emerald-800">
            <Lock className="w-4 h-4" /> {loading ? "Masuk..." : "Masuk"}
          </button>
        </form>
      </div>
    </div>
  );
}
